export const LocalStorage = {
  USER_DETAILS: 'userDetails',
  COGNITO_IDENTITY_SERVICE_PROVIDER: 'CognitoIdentityServiceProvider',
  ACCESS_TOKEN: 'accessToken',
  ID_TOKEN: 'idToken',
};
